
/**
 * Created by saeed on 12/29/2016.
 */

export class IntakeFormVM {

  fields:IntakeFieldVM[]=[];
  collectFormData;

  constructor() {

  }
}
export class IntakeFieldVM
{
  name:string;
  label:string;
  value:string;
  required:boolean;
  placeHolder;
  fieldType:string
  selectorDataTypeId:number;
  options:any[];
  tooltip:string;
  extraSetting:string;
  extraSettingObject:IntakeFieldExtraSettingVM;
  isConditional:boolean;
  conditionalParentFieldName:string;
  conditionalParentValues:string[];

}


export class IntakeFieldExtraSettingVM {
  inputLength:number;
  inputStartWith:string;
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/IntakeForm.model.ts